import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
    children?: ReactNode;
}

interface State {
    hasError: boolean;
    errorInfo: string;
}

class ErrorBoundary extends Component<Props, State> {
    public state: State = {
        hasError: false,
        errorInfo: 'Something went wrong.',
    };

    public static getDerivedStateFromError(_: Error): State {
        // Update state so the next render will show the fallback UI.
        return { hasError: true, errorInfo: 'Something went wrong' };
    }

    public componentDidCatch(error: any, errorInfo: any) {
        console.error('Uncaught error:', error, errorInfo);
        this.setState({
            hasError: error,
            errorInfo: errorInfo,
        });
    }

    public render() {
        if (this.state.hasError) {
            return <h1>{this.state.errorInfo}</h1>;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
